// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1i7Pz","left":"styles_left__2c4nr","desktopActions":"styles_desktopActions__wBOTU","title":"styles_title__IY_sF"};